import React from 'react';
const RealtimeIcon = () => {
  return React.createElement("svg", {
    width: '49',
    height: '49',
    viewBox: '0 0 49 49',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("rect", {
    width: '49',
    height: '49',
    rx: '24.5',
    fill: 'url(#paint0_linear_5_2135)'
  }), React.createElement("rect", {
    width: '49',
    height: '49',
    rx: '24.5',
    fill: 'url(#paint1_radial_5_2135)',
    fillOpacity: '0.6'
  }), React.createElement("path", {
    d: 'M16 27.3152C15.7161 27.3152 15.4757 27.2131 15.279 27.0097C15.0903 26.8063 14.996 26.5625 14.996 26.2782V21.0558C14.996 20.7714 15.0903 20.5276 15.279 20.3242C15.4757 20.1208 15.7161 20.0186 16 20.0186C16.2839 20.0186 16.5243 20.1208 16.721 20.3242C16.9097 20.5276 17.004 20.7714 17.004 21.0558V26.2782C17.004 26.5625 16.9097 26.8063 16.721 27.0097C16.5243 27.2131 16.2839 27.3152 16 27.3152ZM19.6377 31.5097C19.3538 31.5097 19.1134 31.4076 18.9167 31.2042C18.728 31.0008 18.6337 30.757 18.6337 30.4727V18.3268C18.6337 18.0377 18.728 17.7939 18.9167 17.5905C19.1134 17.3871 19.3538 17.285 19.6377 17.285C19.9216 17.285 20.162 17.3871 20.3587 17.5905C20.5474 17.7939 20.6417 18.0377 20.6417 18.3268V30.4727C20.6417 30.757 20.5474 31.0008 20.3587 31.2042C20.162 31.4076 19.9216 31.5097 19.6377 31.5097ZM23.2754 34.2646C22.9915 34.2646 22.7511 34.1625 22.5544 33.9591C22.3657 33.7557 22.2714 33.5119 22.2714 33.2275V14.6892C22.2714 14.4 22.3657 14.1563 22.5544 13.9529C22.7511 13.7495 22.9915 13.6473 23.2754 13.6473C23.5593 13.6473 23.7997 13.7495 23.9964 13.9529C24.1851 14.1563 24.2794 14.4 24.2794 14.6892V33.2275C24.2794 33.5119 24.1851 33.7557 23.9964 33.9591C23.7997 34.1625 23.5593 34.2646 23.2754 34.2646ZM26.9131 29.6773C26.6292 29.6773 26.3888 29.5752 26.1921 29.3718C26.0034 29.1684 25.9091 28.9246 25.9091 28.6402V19.9325C25.9091 19.6481 26.0034 19.4043 26.1921 19.2009C26.3888 18.9975 26.6292 18.8953 26.9131 18.8953C27.197 18.8953 27.4374 18.9975 27.6341 19.2009C27.8228 19.4043 27.9171 19.6481 27.9171 19.9325V28.6402C27.9171 28.9246 27.8228 29.1684 27.6341 29.3718C27.4374 29.5752 27.197 29.6773 26.9131 29.6773ZM30.5508 32.0302C30.2669 32.0302 30.0265 31.9281 29.8298 31.7247C29.6411 31.5213 29.5468 31.2775 29.5468 30.9931V16.0416C29.5468 15.7572 29.6411 15.5134 29.8298 15.31C30.0265 15.1066 30.2669 15.0045 30.5508 15.0045C30.8347 15.0045 31.0751 15.1066 31.2718 15.31C31.4605 15.5134 31.5548 15.7572 31.5548 16.0416V30.9931C31.5548 31.2775 31.4605 31.5213 31.2718 31.7247C31.0751 31.9281 30.8347 32.0302 30.5508 32.0302Z',
    fill: 'white'
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'paint0_linear_5_2135',
    x1: '2.8378',
    y1: '20.1393',
    x2: '27.5877',
    y2: '54.411',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    stopColor: '#7701BB'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#0564ED'
  })), React.createElement("radialGradient", {
    id: 'paint1_radial_5_2135',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(-1.62604 4.44829) rotate(54.1134) scale(24.2294 36.328)'
  }, React.createElement("stop", {
    stopColor: '#F5EBFA'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#C28CE0',
    stopOpacity: '0'
  }))));
};
export default RealtimeIcon;